var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeranjang(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3277 8.34749L6.9307 15.5195C6.9747 16.0715 7.4257 16.4855 7.9767 16.4855H7.9807H18.8917H18.8937C19.4147 16.4855 19.8597 16.0975 19.9337 15.5825L20.8837 9.02349C20.9057 8.86749 20.8667 8.71149 20.7717 8.58549C20.6777 8.45849 20.5397 8.37649 20.3837 8.35449C20.1747 8.36249 11.5017 8.35049 6.3277 8.34749V8.34749ZM7.9747 17.9855C6.6577 17.9855 5.5427 16.9575 5.4357 15.6425L4.5197 4.74849L3.0127 4.48849C2.6037 4.41649 2.3307 4.02949 2.4007 3.62049C2.4727 3.21149 2.8677 2.94549 3.2677 3.00949L5.3477 3.36949C5.6827 3.42849 5.9377 3.70649 5.9667 4.04649L6.2017 6.84749C20.4777 6.85349 20.5237 6.86049 20.5927 6.86849C21.1497 6.94949 21.6397 7.24049 21.9737 7.68849C22.3077 8.13549 22.4477 8.68649 22.3677 9.23849L21.4187 15.7965C21.2397 17.0445 20.1557 17.9855 18.8957 17.9855H18.8907H7.9827H7.9747Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2876 12.0437H14.5156C14.1006 12.0437 13.7656 11.7077 13.7656 11.2937C13.7656 10.8797 14.1006 10.5437 14.5156 10.5437H17.2876C17.7016 10.5437 18.0376 10.8797 18.0376 11.2937C18.0376 11.7077 17.7016 12.0437 17.2876 12.0437",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5445 20.7019C7.8455 20.7019 8.0885 20.9449 8.0885 21.2459C8.0885 21.5469 7.8455 21.7909 7.5445 21.7909C7.2425 21.7909 6.9995 21.5469 6.9995 21.2459C6.9995 20.9449 7.2425 20.7019 7.5445 20.7019",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_505_4672",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 20,
    width: 3,
    height: 2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99899 21.2457C6.99899 21.5477 7.24199 21.7917 7.54499 21.7917V21.7917C7.84599 21.7917 8.08899 21.5477 8.08899 21.2457V21.2457C8.08899 20.9447 7.84599 20.7017 7.54499 20.7017V20.7017C7.24199 20.7017 6.99899 20.9447 6.99899 21.2457V21.2457Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_505_4672)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 26.7907H13.089V15.7017H2V26.7907Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5435 21.0409C7.4305 21.0409 7.3385 21.1329 7.3385 21.2459C7.3385 21.4729 7.7495 21.4729 7.7495 21.2459C7.7495 21.1329 7.6565 21.0409 7.5435 21.0409M7.5435 22.5409C6.8295 22.5409 6.2495 21.9599 6.2495 21.2459C6.2495 20.5319 6.8295 19.9519 7.5435 19.9519C8.2575 19.9519 8.8385 20.5319 8.8385 21.2459C8.8385 21.9599 8.2575 22.5409 7.5435 22.5409",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8248 20.7019C19.1258 20.7019 19.3698 20.9449 19.3698 21.2459C19.3698 21.5469 19.1258 21.7909 18.8248 21.7909C18.5228 21.7909 18.2798 21.5469 18.2798 21.2459C18.2798 20.9449 18.5228 20.7019 18.8248 20.7019",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_505_4672",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 20,
    width: 2,
    height: 2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.28 21.2457C18.28 21.5477 18.523 21.7917 18.825 21.7917V21.7917C19.125 21.7917 19.37 21.5477 19.37 21.2457V21.2457C19.37 20.9447 19.125 20.7017 18.825 20.7017V20.7017C18.523 20.7017 18.28 20.9447 18.28 21.2457V21.2457Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_505_4672)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.28 26.7907H24.37V15.7017H13.28V26.7907Z",
    fill: "black"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8238 21.0409C18.7118 21.0409 18.6198 21.1329 18.6198 21.2459C18.6208 21.4749 19.0308 21.4729 19.0298 21.2459C19.0298 21.1329 18.9368 21.0409 18.8238 21.0409M18.8238 22.5409C18.1098 22.5409 17.5298 21.9599 17.5298 21.2459C17.5298 20.5319 18.1098 19.9519 18.8238 19.9519C19.5388 19.9519 20.1198 20.5319 20.1198 21.2459C20.1198 21.9599 19.5388 22.5409 18.8238 22.5409",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeranjang);
export default __webpack_public_path__ + "static/media/Keranjang.41c155a9817e9f4551802c18dd9bfd47.svg";
export { ForwardRef as ReactComponent };